import { queryOptions } from '@tanstack/react-query';
import {
  fetchTransaction,
  fetchTransactions,
  fetchTransactionsByUser,
  fetchTransactionsByUsers,
} from '../api/transactions';
import { QUERY_KEYS, STALE_TIMES } from '../../utils/constants';

/**
 * Query options factory for the full transactions list.
 */
export const transactionsQueryOptions = () =>
  queryOptions({
    queryKey: QUERY_KEYS.transactions,
    queryFn: fetchTransactions,
    staleTime: STALE_TIMES.transactions,
  });

/**
 * Query options factory for a single transaction by ID.
 */
export const transactionQueryOptions = (id: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.transaction(id),
    queryFn: () => fetchTransaction(id),
    staleTime: STALE_TIMES.transactions,
    enabled: !!id,
  });

/**
 * Query options factory for transactions belonging to a set of users (planet scope).
 * Depends on userIds being populated — use `enabled` to guard.
 */
export const planetTransactionsQueryOptions = (planetId: string, userIds: string[]) =>
  queryOptions({
    queryKey: QUERY_KEYS.planetTransactions(planetId),
    queryFn: () => fetchTransactionsByUsers(userIds),
    staleTime: STALE_TIMES.transactions,
    enabled: userIds.length > 0,
  });

/**
 * Query options factory for transactions belonging to a single user.
 */
export const userTransactionsQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.userTransactions(userId),
    queryFn: () => fetchTransactionsByUser(userId),
    staleTime: STALE_TIMES.transactions,
    enabled: !!userId,
  });
